const PREFIX = "[uiLayout]";

export function logLayoutEvent(event, payload = {}) {
  if (process.env.NODE_ENV === "production") {
    console.info(PREFIX, event, payload);
    return;
  }
  console.info(PREFIX, event, payload);
}

export function logLayoutWarning(event, payload = {}) {
  console.warn(PREFIX, event, payload);
}

export function logLayoutError(event, payload = {}) {
  console.error(PREFIX, event, payload);
}
